import { primary } from '../../../utils/brandColors';

const withCSSVar = (variable, fallback) => `var(${variable}, ${fallback})`;

const rowHover = {
  cursor: 'pointer',
  transition: 'background-color 150ms ease, box-shadow 150ms ease',
  '&:hover': {
    backgroundColor: withCSSVar('--template-palette-action-hover', 'rgba(0,0,0,0.04)'),
    boxShadow: `inset 0 0 0 1px ${withCSSVar('--template-palette-action-selected', 'rgba(0,0,0,0.12)')}`,
  },
};

export default () => ({
  tableContainer: {
    borderRadius: 12,
    border: `1px solid ${withCSSVar('--template-palette-divider', '#E0E0E0')}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    backgroundColor: withCSSVar('--template-palette-background-paper', '#FFFFFF'),
    marginTop: '1rem',
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: 0,
    '& th, & td': {
      padding: '12px 18px',
      borderBottom: `1px solid ${withCSSVar('--template-palette-divider', '#E0E0E0')}`,
      verticalAlign: 'middle',
    },
    '& th:first-of-type, & td:first-of-type': { paddingLeft: 24 },
    '& th:last-of-type, & td:last-of-type': { paddingRight: 24 },
  },
  tableHead: {
    backgroundColor: primary[500],
    '& th': {
      fontWeight: 700,
      fontSize: '0.75rem',
      letterSpacing: 0.5,
      textTransform: 'uppercase',
      color: '#fff',
    },
  },
  tableHeaderCell: { fontWeight: 700 },
  row: rowHover,
  rowInactive: {
    ...rowHover,
    backgroundColor: withCSSVar('--template-palette-action-disabledBackground', 'rgba(0,0,0,0.05)'),
    '& td': { color: withCSSVar('--template-palette-text-secondary', '#6B7280') },
    '&:hover': { backgroundColor: withCSSVar('--template-palette-action-disabledBackground', 'rgba(0,0,0,0.05)') },
  },
  rowComplete: {
    ...rowHover,
    backgroundColor: withCSSVar('--template-palette-action-disabledBackground', 'rgba(0,0,0,0.05)'),
    '& td': { color: withCSSVar('--template-palette-text-secondary', '#6B7280') },
    '&:hover': { backgroundColor: withCSSVar('--template-palette-action-disabledBackground', 'rgba(0,0,0,0.05)') },
  },
  taskNameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  taskName: {
    display: 'flex',
    marginRight: 4,
    fontSize: 18,
  },
  statusCell: {
    padding: '.5em',
    minWidth: 200,
    maxWidth: 300,
  },
});
